<template>
  <div>
    <div class="stat-per" v-if="Summary.length > 0">
      <div class="stat-per-tit">各考勤状态占比</div>
      <div class="stat-per-box">
        <div class="stat-per-item" v-for="item in Summary" :key="item.id">
          <div class="stat-per-img">
            <img :src="require('@/assets/attendance/per01@2x.png')" />
          </div>
          <div class="stat-per-progress">
            <div class="per-progress-top">
              <span class="progress-top-name">{{item.AttTypeName}}</span>
              <span class="progress-top-number">{{item.Ratio}}%</span>
              <span class="progress-top-unit">{{item.AttTypeNum}}人次</span>
            </div>
            <div class="per-progress-btm">
              <van-progress color="#2980FE" :percentage="item.Ratio" :show-pivot="false" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="text-align: center; height: 100px; background:#fff;">暂无数据</div>
  </div>
</template>
<script>
export default {
  name: "MyAttendance",
  data() {
    return {};
  },
  props: ["Summary"],
  created() {},
  mounted() {},

  methods: {}
};
</script>
<style lang="less" scoped>
.stat-per {
  background: #fff;
  margin: 0 20px;
  overflow: hidden;
  .stat-per-tit {
    font-size: 32px;
    font-weight: 500;
    color: rgba(22, 22, 22, 1);
    margin-top: 14px;
    margin-left: 20px;
    margin-bottom: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .stat-per-box {
    margin-top: 10px;
    padding-bottom: 25px;
    .stat-per-item {
      .stat-per-img {
        width: 15%;
        height: 60px;
        display: inline-block;
        margin-top: 44px;
        margin-bottom: 44px;
        text-align: center;
        img {
          width: 46px;
        }
      }
      .stat-per-progress {
        width: 80%;
        display: inline-block;
        margin-top: 44px;
        padding-bottom: 44px;
        border-bottom: 2px solid #eaeaea;
        .per-progress-top {
          margin-bottom: 16px;
          .progress-top-name {
            font-size: 30px;
            font-family: PingFang-SC-Regular, PingFang-SC;
            font-weight: 400;
            color: rgba(22, 22, 22, 1);
            margin-right: 10px;
            vertical-align: middle;
          }
          .progress-top-number {
            font-size: 24px;
            font-family: PingFang-SC-Regular, PingFang-SC;
            font-weight: 400;
            color: rgba(96, 96, 96, 1);
            vertical-align: middle;
          }
          .progress-top-unit {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(22, 22, 22, 1);
            vertical-align: middle;
            float: right;
          }
        }
        // .per-progress-btm{}
      }
    }
  }
}

.more {
  .more-top {
    display: flex;
    margin: 10px;
    .more-top-left {
      flex: 0.333;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
      .school {
        margin-top: 40px;
        margin-bottom: 40px;
        word-wrap: break-word;
        word-break: normal;
        text-align: left;
        padding: 0 9px;
      }
      .active {
        color: #2980fe;
      }
    }
    .more-top-cont {
      flex: 0.333;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
      border-left: 1px solid #eaeaea;
      border-right: 1px solid #eaeaea;
      .grade {
        margin-top: 40px;
        margin-bottom: 40px;
        word-wrap: break-word;
        word-break: normal;
        text-align: left;
        padding: 0 9px;
      }
      .active {
        color: #2980fe;
      }
    }
    .more-top-right {
      flex: 0.333;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
      .class-data {
        margin-top: 40px;
        margin-bottom: 40px;
        word-wrap: break-word;
        word-break: normal;
        text-align: left;
        padding: 0 9px;
      }
      .active {
        color: #2980fe;
      }
    }
  }
  .more-btn {
    display: flex;
    .btn {
      flex: 0.5;
      align-items: center;
      text-align: center;
      justify-content: flex-end;
    }
  }
}
</style>